import React, { Component } from "react";
import { registerForLocalization, provideLocalizationService } from "@progress/kendo-react-intl";
import LoadingPanel from "../../common/LoadingPanel";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { kartyTagyController } from "../../../controllers/kartytagy.controller";

class ZoznamTagov extends Component {
    lastSelectedIndex = 0;

    state = {
        items: [],
        loading: true,
        selectedTag: null
    };

    componentDidMount() {
        this.getZoznamTagov();
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.cisloKarty !== nextProps.cisloKarty) {
            this.getZoznamTagov(nextProps.cisloKarty);
            return false;
        }
        return true;
    }

    getZoznamTagov(cisloKarty) {
        this.setState({ loading: true });

        kartyTagyController.getZoznamTagov(cisloKarty).then((response) => {
            let data = JSON.parse(JSON.stringify(response));

            if (data.errorMessage != null) {
                this.props.handleErrorMessage(data.errorMessage);
            } else {
                var selectedTag = data.items[0] ? data.items[0].tag : null;
                if (data.items[0]) {
                    data.items[0].selected = true;
                }
                this.props.changeSelectedTag(selectedTag);
                this.props.changeSelectedTags(data.items.filter((dataItem) => dataItem.selected).map((a) => a.tag));

                this.setState({
                    items: data.items,
                    loading: false,
                    selectedTag: selectedTag
                });
            }
        });
    }

    changeSelectedTag = (e) => {
        this.props.changeSelectedTag(e.dataItem.tag);
        this.setState({
            selectedTag: e.dataItem.tag
        });

        var items = this.state.items;
        let last = this.lastSelectedIndex;
        const current = items.findIndex((dataItem) => dataItem === e.dataItem);

        if (!e.nativeEvent.shiftKey || !this.props.multiselect) {
            this.lastSelectedIndex = last = current;
        }

        if (!e.nativeEvent.ctrlKey || !this.props.multiselect) {
            items.forEach((item) => (item.selected = false));
        }
        const select = !e.dataItem.selected;
        for (let i = Math.min(last, current); i <= Math.max(last, current); i++) {
            items[i].selected = select;
        }
        this.props.changeSelectedTags(items.filter((dataItem) => dataItem.selected).map((a) => a.tag));

        this.forceUpdate();
    };

    tagyCell = props => {
        var style = { };
        if (props.dataItem.zvyraznit === true) {
            style = { color: "red", fontWeight: "bold" };
        }

        return <td><span style={style}>{props.dataItem.tag}</span></td>;
    };

    renderTable(items) {
        var localizationService = provideLocalizationService(this);

        return (
            <div id="ZoznamTagov" onMouseDown={(e) => e.preventDefault() /* prevents browser text selection */}>
                <Grid
                    data={items}
                    total={items ? items.length : 0}
                    pageSize={items ? items.length : 0}
                    pageable={{ buttonCount: 0, info: true, pageSizes: false, previousNext: false }}
                    selectedField="selected"
                    onRowClick={this.changeSelectedTag}>
                    <GridColumn title={localizationService.toLanguageString("KartyTagy.Grid.Tagy", "Tagy")} cell={this.tagyCell} />
                </Grid>
            </div>
        );
    }

    render() {
        let contents = this.state.loading ? <LoadingPanel /> : this.renderTable(this.state.items);

        return <div>{contents}</div>;
    }
}

export default ZoznamTagov;

registerForLocalization(ZoznamTagov);



// WEBPACK FOOTER //
// ./src/components/dialogs/KartyTagy/ZoznamTagov.js